
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AssignedAttribute": [
      "AssignedBooleanAttribute",
      "AssignedDateAttribute",
      "AssignedDateTimeAttribute",
      "AssignedFileAttribute",
      "AssignedMultiCategoryReferenceAttribute",
      "AssignedMultiChoiceAttribute",
      "AssignedMultiCollectionReferenceAttribute",
      "AssignedMultiPageReferenceAttribute",
      "AssignedMultiProductReferenceAttribute",
      "AssignedMultiProductVariantReferenceAttribute",
      "AssignedNumericAttribute",
      "AssignedPlainTextAttribute",
      "AssignedSingleCategoryReferenceAttribute",
      "AssignedSingleChoiceAttribute",
      "AssignedSingleCollectionReferenceAttribute",
      "AssignedSinglePageReferenceAttribute",
      "AssignedSingleProductReferenceAttribute",
      "AssignedSingleProductVariantReferenceAttribute",
      "AssignedSwatchAttribute",
      "AssignedTextAttribute"
    ],
    "CheckoutLineProblem": [
      "CheckoutLineProblemInsufficientStock",
      "CheckoutLineProblemVariantNotAvailable"
    ],
    "CheckoutProblem": [
      "CheckoutLineProblemInsufficientStock",
      "CheckoutLineProblemVariantNotAvailable",
      "CheckoutProblemDeliveryMethodInvalid",
      "CheckoutProblemDeliveryMethodStale"
    ],
    "DeliveryMethod": [
      "ShippingMethod",
      "Warehouse"
    ],
    "Event": [
      "AccountChangeEmailRequested",
      "AccountConfirmationRequested",
      "AccountConfirmed",
      "AccountDeleteRequested",
      "AccountDeleted",
      "AccountEmailChanged",
      "AccountSetPasswordRequested",
      "AddressCreated",
      "AddressDeleted",
      "AddressUpdated",
      "AppDeleted",
      "AppInstalled",
      "AppStatusChanged",
      "AppUpdated",
      "AttributeCreated",
      "AttributeDeleted",
      "AttributeUpdated",
      "AttributeValueCreated",
      "AttributeValueDeleted",
      "AttributeValueUpdated",
      "CalculateTaxes",
      "CategoryCreated",
      "CategoryDeleted",
      "CategoryUpdated",
      "ChannelCreated",
      "ChannelDeleted",
      "ChannelMetadataUpdated",
      "ChannelStatusChanged",
      "ChannelUpdated",
      "CheckoutCreated",
      "CheckoutFilterShippingMethods",
      "CheckoutFullyAuthorized",
      "CheckoutFullyPaid",
      "CheckoutMetadataUpdated",
      "CheckoutUpdated",
      "CollectionCreated",
      "CollectionDeleted",
      "CollectionMetadataUpdated",
      "CollectionUpdated",
      "CustomerCreated",
      "CustomerDeleted",
      "CustomerMetadataUpdated",
      "CustomerTypeCreated",
      "CustomerTypeDeleted",
      "CustomerTypeUpdated",
      "CustomerUpdated",
      "DraftOrderCreated",
      "DraftOrderDeleted",
      "DraftOrderUpdated",
      "FulfillmentApproved",
      "FulfillmentCanceled",
      "FulfillmentCreated",
      "FulfillmentMetadataUpdated",
      "FulfillmentTrackingNumberUpdated",
      "GiftCardCreated",
      "GiftCardDeleted",
      "GiftCardExportCompleted",
      "GiftCardMetadataUpdated",
      "GiftCardSent",
      "GiftCardStatusChanged",
      "GiftCardUpdated",
      "InvoiceDeleted",
      "InvoiceRequested",
      "InvoiceSent",
      "ListStoredPaymentMethods",
      "MenuCreated",
      "MenuDeleted",
      "MenuItemCreated",
      "MenuItemDeleted",
      "MenuItemUpdated",
      "MenuUpdated",
      "OrderBulkCreated",
      "OrderCancelled",
      "OrderConfirmed",
      "OrderCreated",
      "OrderExpired",
      "OrderFilterShippingMethods",
      "OrderFulfilled",
      "OrderFullyPaid",
      "OrderFullyRefunded",
      "OrderMetadataUpdated",
      "OrderPaid",
      "OrderRefunded",
      "OrderUpdated",
      "PageCreated",
      "PageDeleted",
      "PageTypeCreated",
      "PageTypeDeleted",
      "PageTypeUpdated",
      "PageUpdated",
      "PaymentAuthorize",
      "PaymentCaptureEvent",
      "PaymentConfirmEvent",
      "PaymentGatewayInitializeSession",
      "PaymentGatewayInitializeTokenizationSession",
      "PaymentListGateways",
      "PaymentMethodInitializeTokenizationSession",
      "PaymentMethodProcessTokenizationSession",
      "PaymentProcessEvent",
      "PaymentRefundEvent",
      "PaymentVoidEvent",
      "PermissionGroupCreated",
      "PermissionGroupDeleted",
      "PermissionGroupUpdated",
      "ProductCreated",
      "ProductDeleted",
      "ProductExportCompleted",
      "ProductMediaCreated",
      "ProductMediaDeleted",
      "ProductMediaUpdated",
      "ProductMetadataUpdated",
      "ProductUpdated",
      "ProductVariantBackInStock",
      "ProductVariantBackInStockForClickAndCollect",
      "ProductVariantBackInStockInChannel",
      "ProductVariantCreated",
      "ProductVariantDeleted",
      "ProductVariantDiscountedPriceUpdated",
      "ProductVariantMetadataUpdated",
      "ProductVariantOutOfStock",
      "ProductVariantOutOfStockForClickAndCollect",
      "ProductVariantOutOfStockInChannel",
      "ProductVariantStockUpdated",
      "ProductVariantUpdated",
      "PromotionCreated",
      "PromotionDeleted",
      "PromotionEnded",
      "PromotionRuleCreated",
      "PromotionRuleDeleted",
      "PromotionRuleUpdated",
      "PromotionStarted",
      "PromotionUpdated",
      "SaleCreated",
      "SaleDeleted",
      "SaleToggle",
      "SaleUpdated",
      "ShippingListMethodsForCheckout",
      "ShippingPriceCreated",
      "ShippingPriceDeleted",
      "ShippingPriceUpdated",
      "ShippingZoneCreated",
      "ShippingZoneDeleted",
      "ShippingZoneMetadataUpdated",
      "ShippingZoneUpdated",
      "ShopMetadataUpdated",
      "StaffCreated",
      "StaffDeleted",
      "StaffSetPasswordRequested",
      "StaffUpdated",
      "StoredPaymentMethodDeleteRequested",
      "ThumbnailCreated",
      "TransactionCancelationRequested",
      "TransactionChargeRequested",
      "TransactionInitializeSession",
      "TransactionItemMetadataUpdated",
      "TransactionProcessSession",
      "TransactionRefundRequested",
      "TranslationCreated",
      "TranslationUpdated",
      "VoucherCodeExportCompleted",
      "VoucherCodesCreated",
      "VoucherCodesDeleted",
      "VoucherCreated",
      "VoucherDeleted",
      "VoucherMetadataUpdated",
      "VoucherUpdated",
      "WarehouseCreated",
      "WarehouseDeleted",
      "WarehouseMetadataUpdated",
      "WarehouseUpdated"
    ],
    "IssuingPrincipal": [
      "App",
      "User"
    ],
    "Job": [
      "AppInstallation",
      "ExportFile",
      "Invoice"
    ],
    "Node": [
      "Address",
      "Allocation",
      "App",
      "AppExtension",
      "AppInstallation",
      "AppProblem",
      "AppToken",
      "Attribute",
      "AttributeTranslatableContent",
      "AttributeTranslation",
      "AttributeValue",
      "AttributeValueTranslatableContent",
      "AttributeValueTranslation",
      "Category",
      "CategoryTranslatableContent",
      "CategoryTranslation",
      "Channel",
      "Checkout",
      "CheckoutLine",
      "Collection",
      "CollectionChannelListing",
      "CollectionTranslatableContent",
      "CollectionTranslation",
      "CustomerEvent",
      "CustomerType",
      "EventDelivery",
      "EventDeliveryAttempt",
      "ExportEvent",
      "ExportFile",
      "Fulfillment",
      "FulfillmentLine",
      "GiftCard",
      "GiftCardEvent",
      "GiftCardTag",
      "Group",
      "Invoice",
      "Menu",
      "MenuItem",
      "MenuItemTranslatableContent",
      "MenuItemTranslation",
      "Order",
      "OrderDiscount",
      "OrderEvent",
      "OrderLine",
      "Page",
      "PageTranslatableContent",
      "PageTranslation",
      "PageType",
      "Payment",
      "Product",
      "ProductChannelListing",
      "ProductMedia",
      "ProductMediaTranslatableContent",
      "ProductMediaTranslation",
      "ProductTranslatableContent",
      "ProductTranslation",
      "ProductType",
      "ProductVariant",
      "ProductVariantChannelListing",
      "ProductVariantTranslatableContent",
      "ProductVariantTranslation",
      "Promotion",
      "PromotionCreatedEvent",
      "PromotionEndedEvent",
      "PromotionRule",
      "PromotionRuleCreatedEvent",
      "PromotionRuleDeletedEvent",
      "PromotionRuleTranslatableContent",
      "PromotionRuleTranslation",
      "PromotionRuleUpdatedEvent",
      "PromotionStartedEvent",
      "PromotionTranslatableContent",
      "PromotionTranslation",
      "PromotionUpdatedEvent",
      "Sale",
      "SaleChannelListing",
      "SaleTranslatableContent",
      "SaleTranslation",
      "ShippingMethod",
      "ShippingMethodChannelListing",
      "ShippingMethodPostalCodeRule",
      "ShippingMethodTranslatableContent",
      "ShippingMethodTranslation",
      "ShippingMethodType",
      "ShippingZone",
      "ShopTranslation",
      "StaffNotificationRecipient",
      "Stock",
      "TaxClass",
      "TaxConfiguration",
      "Transaction",
      "TransactionEvent",
      "TransactionItem",
      "User",
      "Voucher",
      "VoucherChannelListing",
      "VoucherTranslatableContent",
      "VoucherTranslation",
      "Warehouse",
      "Webhook"
    ],
    "ObjectWithAttributes": [
      "Page",
      "Product",
      "ProductVariant",
      "User"
    ],
    "ObjectWithMetadata": [
      "Address",
      "App",
      "Attribute",
      "Category",
      "Channel",
      "Checkout",
      "CheckoutLine",
      "Collection",
      "CustomerType",
      "Fulfillment",
      "GiftCard",
      "Invoice",
      "Menu",
      "MenuItem",
      "Order",
      "OrderLine",
      "Page",
      "PageType",
      "Payment",
      "Product",
      "ProductMedia",
      "ProductType",
      "ProductVariant",
      "Promotion",
      "Sale",
      "ShippingMethod",
      "ShippingMethodType",
      "ShippingZone",
      "Shop",
      "TaxClass",
      "TaxConfiguration",
      "TransactionItem",
      "User",
      "Voucher",
      "Warehouse"
    ],
    "OrderOrCheckout": [
      "Checkout",
      "Order"
    ],
    "PaymentMethodDetails": [
      "CardPaymentMethodDetails",
      "GiftCardPaymentMethodDetails",
      "OtherPaymentMethodDetails"
    ],
    "PromotionEvent": [
      "PromotionCreatedEvent",
      "PromotionEndedEvent",
      "PromotionRuleCreatedEvent",
      "PromotionRuleDeletedEvent",
      "PromotionRuleUpdatedEvent",
      "PromotionStartedEvent",
      "PromotionUpdatedEvent"
    ],
    "PromotionEventInterface": [
      "PromotionCreatedEvent",
      "PromotionEndedEvent",
      "PromotionRuleCreatedEvent",
      "PromotionRuleDeletedEvent",
      "PromotionRuleUpdatedEvent",
      "PromotionStartedEvent",
      "PromotionUpdatedEvent"
    ],
    "PromotionRuleEventInterface": [
      "PromotionRuleCreatedEvent",
      "PromotionRuleDeletedEvent",
      "PromotionRuleUpdatedEvent"
    ],
    "ReferenceType": [
      "PageType",
      "ProductType"
    ],
    "TaxSourceLine": [
      "CheckoutLine",
      "OrderLine"
    ],
    "TaxSourceObject": [
      "Checkout",
      "Order"
    ],
    "TranslatableItem": [
      "AttributeTranslatableContent",
      "AttributeValueTranslatableContent",
      "CategoryTranslatableContent",
      "CollectionTranslatableContent",
      "MenuItemTranslatableContent",
      "PageTranslatableContent",
      "ProductMediaTranslatableContent",
      "ProductTranslatableContent",
      "ProductVariantTranslatableContent",
      "PromotionRuleTranslatableContent",
      "PromotionTranslatableContent",
      "SaleTranslatableContent",
      "ShippingMethodTranslatableContent",
      "VoucherTranslatableContent"
    ],
    "TranslationTypes": [
      "AttributeTranslation",
      "AttributeValueTranslation",
      "CategoryTranslation",
      "CollectionTranslation",
      "MenuItemTranslation",
      "PageTranslation",
      "ProductMediaTranslation",
      "ProductTranslation",
      "ProductVariantTranslation",
      "PromotionRuleTranslation",
      "PromotionTranslation",
      "SaleTranslation",
      "ShippingMethodTranslation",
      "VoucherTranslation"
    ],
    "UserOrApp": [
      "App",
      "User"
    ],
    "_Entity": [
      "Address",
      "App",
      "Category",
      "Collection",
      "Group",
      "Order",
      "PageType",
      "Product",
      "ProductMedia",
      "ProductType",
      "ProductVariant",
      "User"
    ]
  }
};
      export default result;
    